import React from 'react';
import GrayShadowBox from '../../GrayShadowBox';
import Button from '../../Button';

const ProductTags = ({ 
    tags,
    newTag,
    onTagAdd,
    onTagRemove,
    onTagKeyPress,
    onNewTagChange,
    onSave
}) => {
    return (
        <GrayShadowBox>
            <div className="space-y-4">
                {/* 태그 선택 */}
                <div>
                    <h3 className="text-lg font-medium text-gray-700 mb-3">태그 선택</h3>
                    <div className="space-y-3">
                        {/* 기존 태그들 */}
                        <div className="flex flex-wrap gap-2">
                            {tags.map((tag, index) => (
                                <span
                                    key={index}
                                    className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800"
                                >
                                    #{tag}
                                    <button
                                        onClick={() => onTagRemove(tag)}
                                        className="ml-2 text-blue-600 hover:text-blue-800"
                                    >
                                        ×
                                    </button>
                                </span>
                            ))}
                        </div>
                        
                        {/* 새 태그 추가 */}
                        <div className="flex gap-2">
                            <input
                                type="text"
                                value={newTag}
                                onChange={(e) => onNewTagChange(e.target.value)}
                                onKeyPress={onTagKeyPress}
                                placeholder="새 태그 입력"
                                className="flex-1 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                            <Button
                                onClick={onTagAdd}
                                variant="secondary"
                                size="sm"
                                disabled={!newTag.trim()}
                            >
                                추가
                            </Button>
                        </div>
                        
                        {/* 기본 제공 태그 버튼들 */}
                        <div className="mt-3">
                            <p className="text-sm text-gray-600 mb-2">기본 제공 태그:</p>
                            <div className="flex flex-wrap gap-2">
                                {['pre-order', 'BO', 'PO-Album', 'PO-MD'].map((presetTag) => (
                                    <button
                                        key={presetTag}
                                        onClick={() => {
                                            if (!tags.includes(presetTag)) {
                                                onTagAdd(presetTag);
                                            }
                                        }}
                                        disabled={tags.includes(presetTag)}
                                        className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                                            tags.includes(presetTag)
                                                ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-800'
                                        }`}
                                    >
                                        #{presetTag}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 액션 버튼들 */}
            <div className="flex justify-end gap-3 mt-6">
                <Button
                    onClick={onSave}
                    variant="basicNavy"
                    size="sm"
                >
                    저장
                </Button>
            </div>
        </GrayShadowBox>
    );
};

export default ProductTags;

